module.exports = __webpack_public_path__ + "img/user_profile.068bb658.svg";